import { enZA } from "../../../../date-fns/locale/en-ZA.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enZA
  }
};